import { Box, Typography } from "@mui/material";
import { COLORS } from "../../configs/config";

export const ChartLegend = ({ items }) => (
    <Box display="flex" gap={2} mb={1}>
        {items.map((l, i) => (
            <Box key={i} display="flex" alignItems="center" gap={0.5}>
                <Box sx={{
                    width: l.dash ? 20 : 8,
                    height: l.dash ? 0 : 8,
                    bgcolor: l.dash ? "transparent" : l.color,
                    borderRadius: l.dash ? 0 : 0.5,
                    borderTop: l.dash ? `2px dashed ${l.color}` : "none",
                }} />
                <Typography variant="caption" sx={{ color: COLORS.tDim }}>{l.label}</Typography>
            </Box>
        ))}
    </Box>
);